import { Component, OnInit, Injector, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { GaStudyTitlesGridTemplate } from './ga-study-titles-grid.template';

@Component({
  selector: 'ga-study-titles-dialog',
  templateUrl: './ga-study-titles-dialog.component.html',
})
export class GaStudyTitlesDialogComponent implements OnInit {
  data: any = {};
  gridTemplate: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<GaStudyTitlesDialogComponent>,
    injector: Injector
  ) {
    this.data = data;
    this.gridTemplate = new GaStudyTitlesGridTemplate(injector);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

  onYesClick(): any {
    const ids: any[] = [];
    this.gridTemplate.selectedRows.forEach(element => {
      ids.push(element.dataItem.Id);
    });
    this.dialogRef.close(ids);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isDisabled() {
    return this.gridTemplate.selectedRows.length === 0;
  }
}
